import { useMutation } from "react-query";
import { editScript } from "../../../../actions/Utilities/ScriptConfiguration";

export const useEditScript = () => {
  return useMutation(editScript);
};
